import reduxCrud from 'redux-crud';

const tripEventsActionCreators = reduxCrud.actionCreatorsFor('tripEvents', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('tripEvents', { key: 'id' });

export default tripEventsActionCreators;
export { actionTypes };
